import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
import { putAccountsApi, getSecureAccountsApi, putS3Data, postSecureAccountsApi, deleteAccountsApi, postAccountsApi, getPublicApi, getAccountsApi, getMainApi, getPublicDocumentsApi, getDocumentsApiNoAuth, postPublicDocumentsApi, putDocumentsApiNoAuth } from "../../../../../shared/utils/ajax";
import { MAIN_API } from "@Shared/@Utils/constants";
export const getAccountDetails = async () => {
  return getSecureAccountsApi({}, "");
};
export const getNotificationPreferences = () => {
  const endpoint = "/notification/preferences";
  return getSecureAccountsApi({}, endpoint);
};
export const updateNotificationPreferences = preferences => {
  const endpoint = "/notification/preferences";
  return putAccountsApi(preferences, endpoint);
};
export const updateAccountPreferences = preferences => {
  const endpoint = "/preferences";
  return putAccountsApi(preferences, endpoint);
};
export const updatePersonalDetails = async details => {
  return putAccountsApi(details, "");
};
export const changePassword = async (currentPassword, newPassword, email) => {
  const endpoint = "/change-password";
  return postSecureAccountsApi({
    email,
    currentPassword,
    newPassword
  }, endpoint);
};
export const uploadToS3 = async (file, endpoint, contentType) => {
  return await putS3Data(file, endpoint, contentType);
};
export const setProfilePhoto = async () => {
  const endpoint = "/profile-photo";
  return postSecureAccountsApi({}, endpoint);
};
export const getPhotoSignedURL = async fileName => {
  const endpoint = "/profile-photo/signed-s3-url";
  return getSecureAccountsApi({
    fileName
  }, endpoint);
};
export const removeProfilePhoto = async () => {
  const endpoint = "/profile-photo";
  return deleteAccountsApi(endpoint);
};
export const createAccount = async accountDetails => {
  return postAccountsApi(accountDetails, "");
};
export const verifyAccountEmail = async (email, token) => {
  return postAccountsApi({
    email,
    t: token
  }, "/verify-account");
};
export const resendConfirmationLink = async (email, currentSubdomain, locale = "en-CA") => {
  return postAccountsApi({
    email,
    currentSubdomain,
    locale
  }, "/resend-confirmation-code");
};
export const verifyAccountEmailCode = async (email, confirmationCode) => {
  return postAccountsApi({
    email,
    confirmationCode
  }, "/verify-account");
};
export const resendConfirmationCode = async email => {
  return postAccountsApi({
    email
  }, "/resend-confirmation-code");
};
export const retrieveApplicationinfo = async token => {
  return getPublicApi({
    t: token
  }, `${MAIN_API}/brokers/application`);
};
export const getAgentAccountDetails = (pathname, token) => {
  return getAccountsApi({}, `/subdomain${pathname}`, token);
};
export const login = async (email, password, currentSubdomain = "", deviceConfig) => {
  return postAccountsApi({
    email,
    password,
    currentSubdomain,
    deviceConfig
  }, "/login");
};
export const logout = async token => {
  return postAccountsApi({
    token
  }, "/logout");
};
export const checkIfAccountEmailExists = email => {
  const endpoint = `${MAIN_API}/clients/account/email-exists/${email}`;
  return getPublicApi({}, endpoint);
};
export const getAgents = async () => {
  return getMainApi({}, "/agents");
};
export const getLenderDocuments = async (urlId, offset) => {
  return getPublicDocumentsApi({
    offset
  }, "", `/guest-lender/${urlId}`);
};
export const verifyLenderCode = async (urlId, code) => {
  return postPublicDocumentsApi({
    urlId,
    code
  }, "", "/guest-lender/verify-code");
};
export const downloadAllDocumentsAsZip = async (urlId, documentIds) => {
  const endpoint = `guest-lender/${urlId}/zip`;
  return getDocumentsApiNoAuth({
    documentIds: btoa(_JSON$stringify({
      documentIds
    }))
  }, endpoint);
};
export const downloadDocument = (documentId, fileName, applicationId, clientUsername, download = true) => {
  const endpoint = `/${documentId}`;
  return getDocumentsApiNoAuth({
    fileName,
    client: clientUsername,
    applicationId: applicationId,
    download
  }, endpoint);
};
export const downloadAllDocumentsAsPdf = async (urlId, documentIds) => {
  const endpoint = `guest-lender/${urlId}/combined-pdf`;
  return getDocumentsApiNoAuth({
    documentIds: btoa(_JSON$stringify({
      documentIds
    }))
  }, endpoint);
};
export const markDocumentsDownloaded = async (urlId, documentIds) => {
  const endpoint = `guest-lender/${urlId}/mark-documents-downloaded`;
  return putDocumentsApiNoAuth({
    documentIds: btoa(_JSON$stringify({
      documentIds
    }))
  }, endpoint);
};